import { createReducer } from '@reduxjs/toolkit';

import postEasyShipRates from '../../../thunks/shipment/easyShip/postEasyShipRates';

const initialState = {
  loading: false,
  error: null,
  data: undefined,
};

const postEasyShipRatesReducer = createReducer(initialState, {
  [postEasyShipRates.pending]: (state) => ({
    ...state,
    loading: true,
    error: null,
  }),
  [postEasyShipRates.fulfilled]: (state, { payload }) => ({
    ...state,
    loading: false,
    data: payload
  }),
  [postEasyShipRates.rejected]: (state, { payload }) => ({
    ...state,
    loading: false,
    error: payload,
    data: undefined
  }),
});

export default postEasyShipRatesReducer;
